import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'

export default function Mradi() {
  const [open, setOpen] = useState(false)

  return (
    <div>

    <button
  type="button"
  className=" bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
  onClick={() => setOpen(true)}
>
  Learn More
</button>

    

    <Transition.Root show={open} as={Fragment}>
       
      
      <Dialog as="div" className="relative z-10" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto relative w-screen max-w-md">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute left-0 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4">
                      <button
                        type="button"
                        className="rounded-md text-gray-300 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                        onClick={() => setOpen(false)}
                      >
                        <span className="sr-only">Close panel</span>
                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                    <div className="px-4 sm:px-6">
                      <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                        Mradi
                      </Dialog.Title>
                      <Dialog.Description>

                        <p className='pt-4 italic'>Make Your Project Goals a Reality</p>
                        <p>What is that goal that you really wish you could achieve? A goal is a dream with a deadline and The Mradi Wallet is designed to specifically help you achieve that dream. It is a short-term digital savings Wallet focused on making your life goals a reality. Whatever your project could be,be it a new phone, your wedding plans, a Master’s Degree or a new car, this project wallet is the vehicle that will help you get there.</p>
                        <p className='pt-4'><b>Key benefits for the Mradi Wallet</b></p>
                        <br/><br/>-Digital Wallet: Invest, Top-up, Check balance and withdrawal conveniently through your mobile phone by dialing *778#.
                        <br/><br/>-Superior returns: earn competitive returns of between 8 - 12% per annum
                        <br/><br/>-Flexible: Flexible: The Msafiri Wallet allows you to contribute a minimum of only Kes 200 daily, weekly or monthly and a maximum investment of Kes 140,000 per day.
                        <br/><br/>-Free Life Insurance: This wallet comes with a free Life Insurance cover of Kes 50,000
                        <br/><br/>-Multiple Wallets:You can create as many wallets as you want and customize the wallet names to your liking.
                        <br/><br/>-No withholding tax: The interest you earn form your investment is not subjected to withholding tax. This means that you save 15% tax on the interest. Further, you can also apply for tax relief if your policy is for a duration of 10 years or more.



                      </Dialog.Description>
                    </div>
                    <div className="relative mt-6 flex-1 px-4 sm:px-6">{/* Your content */}</div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
    </div>
  )
}
